import React, { useEffect, useRef } from 'react';

interface AdLeaderboardHeroProps {
  className?: string;
}

const AdLeaderboardHero: React.FC<AdLeaderboardHeroProps> = ({ className }) => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current || !adContainerRef.current) return;
    
    // Create and inject the script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.diclotrans.com/sdk/v1/51379/dd1d7723314497b62e73f9a1c04a2d6fb2e8d905/lib.js';
    script.async = true;
    
    // Append the script to the container
    adContainerRef.current.appendChild(script);
    
    isScriptInjected.current = true;
    
    // Cleanup function
    return () => {
      if (adContainerRef.current) {
        const scriptElement = adContainerRef.current.querySelector('script[src="https://cdn.diclotrans.com/sdk/v1/51379/dd1d7723314497b62e73f9a1c04a2d6fb2e8d905/lib.js"]');
        if (scriptElement) {
          adContainerRef.current.removeChild(scriptElement);
        }
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div 
      ref={adContainerRef} 
      className={`ad-leaderboard-hero w-full overflow-hidden ${className || ''}`}
      style={{ height: '90px', maxWidth: '728px', margin: '0 auto' }}
    />
  );
};

export default AdLeaderboardHero;